import { IApplicationState } from '../../types/redux';

export const selectConstructionProgressLoading = (state: IApplicationState) => {
  const { isLoading } = state.constructionProgressData;

  return isLoading;
};
